import { Action } from '@ngrx/store';

export enum TranslationsActionTypes {
  ChangeLanguage = '[Translations] Load Translations',
  ResetLanguage =  '[Translations] Reset Translations'

}

export class ChangeLanguage implements Action {
  readonly type = TranslationsActionTypes.ChangeLanguage;
  constructor(public payload: string) {}
}

export class ResetLanguage implements Action {
  readonly type = TranslationsActionTypes.ResetLanguage;
  constructor(public payload: string) {}
}


export type TranslationsActions =
  | ChangeLanguage
  | ResetLanguage;
